import { render } from "./confirmComponent.vue?vue&type=template&id=2351e43a&scoped=true"
import script from "./confirmComponent.vue?vue&type=script&lang=js"
export * from "./confirmComponent.vue?vue&type=script&lang=js"

import "./confirmComponent.vue?vue&type=style&index=0&id=2351e43a&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2351e43a"]])

export default __exports__